export const MAX_SELECTED_THREADS_NUMBER = 15;

export const THREAD_CATEGORY_COLORS = {
    rose: 'fb7185',
    pink: 'f472b6',
    fuchsia: 'e879f9',
    violet: 'a78bfa',
    blue: '60a5fa',
    sky: '38bdf8',
    emerald: '34d399',
    lime: 'a3e635',
    amber: 'fbbf24',
    orange: 'fb923c',
    slate: '94a3b8',
} as const;

export const THREAD_CATEGORY_COLORS_OPTIONS: { label: string; value: string }[] = Object.entries(
    THREAD_CATEGORY_COLORS
).map(([label, value]) => ({ label, value }));

export const THREAD_SECTIONS = {
    needs_action: { value: 'needs_action', label: 'Needs Action', color: 'rose', badgeColor: 'rose' },
    follow_up: { value: 'follow_up', label: 'Follow-Up Recommended', color: 'amber', badgeColor: 'amber' },
    awaiting_reply: { value: 'awaiting_reply', label: 'Awaiting Customer Reply', color: 'sky', badgeColor: 'sky' },
    snoozed: { value: 'snoozed', label: 'Snoozed', color: 'slate', badgeColor: 'slate' },
    completed: { value: 'completed', label: 'Done', color: 'emerald', badgeColor: 'success' },
    pending: { value: 'pending', label: 'Pending', color: 'slate', badgeColor: 'slate' },
} as const;

export type ThreadSectionValue = keyof typeof THREAD_SECTIONS;

export function isThreadSectionValue(value: string | null | undefined): value is ThreadSectionValue {
    return value !== null && value !== undefined && value in THREAD_SECTIONS;
}

export const ACTIVE_THREAD_SECTIONS: ThreadSectionValue[] = ['needs_action', 'follow_up', 'awaiting_reply'];
